module.exports = __webpack_public_path__ + "static/img/tb-logo-grey.6800a961.svg";